import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77a65275"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "presenter-view" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "普通视图", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "画笔", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "激光笔", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计时器", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结束放映", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "remark" }
const _hoisted_11 = { class: "header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "演讲者备注", -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "remark-scale" }

import { computed, nextTick, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import type { ContextmenuItem } from '@/components/Contextmenu/types'
import { enterFullscreen } from '@/utils/fullscreen'
import { parseText2Paragraphs } from '@/utils/textParser'
import useScreening from '@/hooks/useScreening'
import useLoadSlides from '@/hooks/useLoadSlides'
import useExecPlay from './hooks/useExecPlay'
import useSlideSize from './hooks/useSlideSize'
import useFullscreen from './hooks/useFullscreen'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import ScreenSlideList from './ScreenSlideList.vue'
import WritingBoardTool from './WritingBoardTool.vue'
import CountdownTimer from './CountdownTimer.vue'
import Divider from '@/components/Divider.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PresenterView',
  props: {
    changeViewMode: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { slides, slideIndex, viewportRatio, currentSlide } = storeToRefs(useSlidesStore())

const slideListWrapRef = ref<HTMLElement>()
const thumbnailsRef = ref<HTMLElement>()
const writingBoardToolVisible = ref(false)
const timerlVisible = ref(false)
const laserPen = ref(false)

const {
  mousewheelListener,
  touchStartListener,
  touchEndListener,
  turnPrevSlide,
  turnNextSlide,
  turnSlideToIndex,
  turnSlideToId,
  animationIndex,
} = useExecPlay()

const { slideWidth, slideHeight } = useSlideSize(slideListWrapRef)
const { exitScreening } = useScreening()
const { slidesLoadLimit } = useLoadSlides()
const { fullscreenState, manualExitFullscreen } = useFullscreen()

const remarkFontSize = ref(16)
const currentSlideRemark = computed(() => {
  return parseText2Paragraphs(currentSlide.value.remark || '无备注')
})

const handleMousewheelThumbnails = (e: WheelEvent) => {
  if (!thumbnailsRef.value) return
  thumbnailsRef.value.scrollBy(e.deltaY, 0)
}

const setRemarkFontSize = (fontSize: number) => {
  if (fontSize < 12 || fontSize > 40) return
  remarkFontSize.value = fontSize
}

watch(slideIndex, () => {
  nextTick(() => {
    if (!thumbnailsRef.value) return

    const activeThumbnailRef: HTMLElement | null = thumbnailsRef.value.querySelector('.thumbnail.active')
    if (!activeThumbnailRef) return

    const width = thumbnailsRef.value.offsetWidth
    const offsetLeft = activeThumbnailRef.offsetLeft
    thumbnailsRef.value.scrollTo({ left: offsetLeft - width / 2, behavior: 'smooth' })
  })
})

const contextmenus = (): ContextmenuItem[] => {
  return [
    {
      text: '上一页',
      subText: '↑ ←',
      disable: slideIndex.value <= 0,
      handler: () => turnPrevSlide(),
    },
    {
      text: '下一页',
      subText: '↓ →',
      disable: slideIndex.value >= slides.value.length - 1,
      handler: () => turnNextSlide(),
    },
    {
      text: '第一页',
      disable: slideIndex.value === 0,
      handler: () => turnSlideToIndex(0),
    },
    {
      text: '最后一页',
      disable: slideIndex.value === slides.value.length - 1,
      handler: () => turnSlideToIndex(slides.value.length - 1),
    },
    { divider: true },
    {
      text: '画笔工具',
      handler: () => writingBoardToolVisible.value = true,
    },
    {
      text: '普通视图',
      handler: () => props.changeViewMode('base'),
    },
    { divider: true },
    {
      text: '结束放映',
      subText: 'ESC',
      handler: exitScreening,
    },
  ]
}

return (_ctx: any,_cache: any) => {
  const _component_IconListView = _resolveComponent("IconListView")!
  const _component_IconWrite = _resolveComponent("IconWrite")!
  const _component_IconMagic = _resolveComponent("IconMagic")!
  const _component_IconStopwatchStart = _resolveComponent("IconStopwatchStart")!
  const _component_IconOffScreenOne = _resolveComponent("IconOffScreenOne")!
  const _component_IconPower = _resolveComponent("IconPower")!
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "tool-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeViewMode('base')))
      }, [
        _createVNode(_component_IconListView, { class: "tool-icon" }),
        _hoisted_3
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tool-btn", { 'active': writingBoardToolVisible.value }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (writingBoardToolVisible.value = !writingBoardToolVisible.value))
      }, [
        _createVNode(_component_IconWrite, { class: "tool-icon" }),
        _hoisted_4
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tool-btn", { 'active': laserPen.value }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (laserPen.value = !laserPen.value))
      }, [
        _createVNode(_component_IconMagic, { class: "tool-icon" }),
        _hoisted_5
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tool-btn", { 'active': timerlVisible.value }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (timerlVisible.value = !timerlVisible.value))
      }, [
        _createVNode(_component_IconStopwatchStart, { class: "tool-icon" }),
        _hoisted_6
      ], 2),
      _createElementVNode("div", {
        class: "tool-btn",
        onClick: _cache[4] || (_cache[4] = () => _unref(fullscreenState) ? _unref(manualExitFullscreen)() : _unref(enterFullscreen)())
      }, [
        (_unref(fullscreenState))
          ? (_openBlock(), _createBlock(_component_IconOffScreenOne, {
              key: 0,
              class: "tool-icon"
            }))
          : (_openBlock(), _createBlock(_component_IconOffScreenOne, {
              key: 1,
              class: "tool-icon"
            })),
        _createElementVNode("span", null, _toDisplayString(_unref(fullscreenState) ? '退出全屏' : '全屏'), 1)
      ]),
      _createVNode(Divider, { class: "divider" }),
      _createElementVNode("div", {
        class: "tool-btn",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(exitScreening)()))
      }, [
        _createVNode(_component_IconPower, { class: "tool-icon" }),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass(["slide-list-wrap", { 'laser-pen': laserPen.value }]),
        ref_key: "slideListWrapRef",
        ref: slideListWrapRef
      }, [
        _withDirectives(_createVNode(ScreenSlideList, {
          slideWidth: _unref(slideWidth),
          slideHeight: _unref(slideHeight),
          animationIndex: _unref(animationIndex),
          turnSlideToId: _unref(turnSlideToId),
          manualExitFullscreen: _unref(manualExitFullscreen),
          onWheel: _cache[6] || (_cache[6] = $event => _unref(mousewheelListener)($event)),
          onTouchstart: _cache[7] || (_cache[7] = $event => _unref(touchStartListener)($event)),
          onTouchend: _cache[8] || (_cache[8] = $event => _unref(touchEndListener)($event))
        }, null, 8, ["slideWidth", "slideHeight", "animationIndex", "turnSlideToId", "manualExitFullscreen"]), [
          [_directive_contextmenu, contextmenus]
        ]),
        (writingBoardToolVisible.value)
          ? (_openBlock(), _createBlock(WritingBoardTool, {
              key: 0,
              slideWidth: _unref(slideWidth),
              slideHeight: _unref(slideHeight),
              left: -365,
              top: -155,
              onClose: _cache[9] || (_cache[9] = ($event: any) => (writingBoardToolVisible.value = false))
            }, null, 8, ["slideWidth", "slideHeight"]))
          : _createCommentVNode("", true),
        (timerlVisible.value)
          ? (_openBlock(), _createBlock(CountdownTimer, {
              key: 1,
              left: 75,
              onClose: _cache[10] || (_cache[10] = ($event: any) => (timerlVisible.value = false))
            }))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: "thumbnails",
        ref_key: "thumbnailsRef",
        ref: thumbnailsRef,
        onWheel: _cache[11] || (_cache[11] = _withModifiers($event => handleMousewheelThumbnails($event), ["prevent"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["thumbnail", { 'active': index === _unref(slideIndex) }]),
            key: slide.id,
            onClick: ($event: any) => (_unref(turnSlideToIndex)(index))
          }, [
            _createVNode(ThumbnailSlide, {
              slide: slide,
              size: 120 / _unref(viewportRatio),
              visible: index < _unref(slidesLoadLimit)
            }, null, 8, ["slide", "size", "visible"])
          ], 10, _hoisted_9))
        }), 128))
      ], 544)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, "P " + _toDisplayString(_unref(slideIndex) + 1) + " / " + _toDisplayString(_unref(slides).length), 1)
      ]),
      _createElementVNode("div", {
        class: "remark-content ProseMirror-static",
        style: _normalizeStyle({ fontSize: remarkFontSize.value + 'px' }),
        innerHTML: currentSlideRemark.value
      }, null, 12, _hoisted_13),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: _normalizeClass(['scale-btn', { 'disable': remarkFontSize.value === 12 }]),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (setRemarkFontSize(remarkFontSize.value - 2)))
        }, [
          _createVNode(_component_IconMinus)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['scale-btn', { 'disable': remarkFontSize.value === 40 }]),
          onClick: _cache[13] || (_cache[13] = ($event: any) => (setRemarkFontSize(remarkFontSize.value + 2)))
        }, [
          _createVNode(_component_IconPlus)
        ], 2)
      ])
    ])
  ]))
}
}

})